/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Timeline_Font_ColorInputs */

const en_options_editor_timeline_font_color = /** @type {(inputs: Options_Editor_Timeline_Font_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Font Color`)
};

const fr_options_editor_timeline_font_color = /** @type {(inputs: Options_Editor_Timeline_Font_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur de police`)
};

const de_options_editor_timeline_font_color = /** @type {(inputs: Options_Editor_Timeline_Font_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftfarbe`)
};

const it_options_editor_timeline_font_color = /** @type {(inputs: Options_Editor_Timeline_Font_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colore del carattere`)
};

const ru_options_editor_timeline_font_color = /** @type {(inputs: Options_Editor_Timeline_Font_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цвет шрифта`)
};

const es_options_editor_timeline_font_color = /** @type {(inputs: Options_Editor_Timeline_Font_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color de fuente`)
};

const zh_cn2_options_editor_timeline_font_color = /** @type {(inputs: Options_Editor_Timeline_Font_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字体颜色`)
};

const ja_options_editor_timeline_font_color = /** @type {(inputs: Options_Editor_Timeline_Font_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォント色`)
};

const hi_options_editor_timeline_font_color = /** @type {(inputs: Options_Editor_Timeline_Font_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ॉन्ट रंग`)
};

const pt_pt2_options_editor_timeline_font_color = /** @type {(inputs: Options_Editor_Timeline_Font_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor da fonte`)
};

/**
* | output |
* | --- |
* | "Font Color" |
*
* @param {Options_Editor_Timeline_Font_ColorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_timeline_font_color = /** @type {((inputs?: Options_Editor_Timeline_Font_ColorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Timeline_Font_ColorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_timeline_font_color(inputs)
	if (locale === "de") return de_options_editor_timeline_font_color(inputs)
	if (locale === "it") return it_options_editor_timeline_font_color(inputs)
	if (locale === "ru") return ru_options_editor_timeline_font_color(inputs)
	if (locale === "es") return es_options_editor_timeline_font_color(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_timeline_font_color(inputs)
	if (locale === "ja") return ja_options_editor_timeline_font_color(inputs)
	if (locale === "hi") return hi_options_editor_timeline_font_color(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_timeline_font_color(inputs)
	return en_options_editor_timeline_font_color(inputs)
});